/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
<template>
  <div>
    <!-- <div class="indexSwiperBanner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="(carouselItem, carouselIndex) in carouselList"
          :key="carouselIndex"
        >
          <div @click="linkUrl(carouselItem.url)">
            <img :src="carouselItem.img" alt="" mode="aspectFill" />
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
				<div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div> -->
    <div :id="maxscrollTop ? 'commonGoTopNav' : ''" class="navBox">
      <div class="commonNavBox">
        <div
          :class="tabOpt == index ? 'tabList tabOpt' : 'tabList'"
          v-for="(item, index) in productClassList"
          :key="index"
          @click="handleClick(index)"
        >
          <div class="text">{{ item.catname }}</div>
        </div>
      </div>
    </div>
    <div class="productBox">
      <div class="productListBox">
        <div
          class="productListPart"
          v-for="(item, index) in productList"
          :key="index"
        >
          <div class="className tab">{{ item.catname }}</div>
          <div class="productList">
            <div
              class="productItem"
              v-for="(productItem, productIndex) in item.list"
              :key="productIndex"
              @mouseover="showMask(productItem)"
              @mouseout="showMask(productItem)"
            >
              <img class="productImg" :src="$imgUrl.imgUrl(productItem.thumb)" alt="" />
              <div
                class="textArea textLinesLimit_1"
                v-show="productItem.maskShow == false"
              >
                {{ productItem.title }}
              </div>
              <div class="product_mask" v-show="productItem.maskShow == true">
                <div class="preview_btn" @click="goPreview(productItem)">
                  <img src="../../src/img/eyes_icon.png" alt="" />
                  <div>Preview the file</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="pagination">
					<el-pagination
						background
						layout="prev, pager, next"
					:total="1000">
					</el-pagination>
				</div> -->
      </div>
    </div>
    <div class="dialog" v-show="pdfDialog">
      <div class="mask"></div>
      <div class="dialog_content">
        <i class="el-icon-close dialogPdfClose" @click="pdfClose()"></i>
        <div class="pdfBox">
          <pdf v-for="i in numPages" :key="i" :page="i" :src="pdfUrl"></pdf>
        </div>
        <a @click="downloadFile(pdfUrl)"><i></i></a>
      </div>
    </div>
  </div>
</template>

<script>
import * as axios from "../../src/axios/api.js";
import imgUrl from "../../src/utils/imgUrl.js";
import pdf from 'vue-pdf';
export default {
  components:{
      pdf
  },
  data() {
    return {
      pdfUrl:'',
      numPages:1,
      pdfDialog:false,
      //banner: {},
      maxscrollTop: false,
      carouselList: [
        
      ],
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
      productClassList: [
        // "Cutting Board Series",
        // "Table Ware",
        // "Kitchenware Series",
        // "Children Series",
        // "Cup Series",
      ],
      tabOpt: 0,
      productList: [
      ],
    };
  },
  watch: {
    pdfDialog(val){
      var that=this
      if (val) {
        document.body.style.overflow='hidden';
        document.body.style.position='fixed';
        document.body.style.width='100%';
        document.addEventListener('touchmove', that.default, {
          passive: false
        }) // 禁止页面滑动
      } else {
        document.body.style.overflow='';//出现滚动条
        document.body.style.position='initial';
        document.body.style.height='100vh';
        document.removeEventListener('touchmove', that.default, {
          passive: false
        })
      }
    },
    $route: {
      handler: function (val, oldVal) {
        if (val.query.index) {
          this.index = val.query.index;
          setTimeout(() => {
            this.handleClick(val.query.index,false);
          }, 500);
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    let id = this.$route.query.id;
    this.getProductList(id);
  },
  mounted() {
    if (this.$route.query.index) {
      var that=this
      that.index = that.$route.query.index;
      setTimeout(() => {
        that.handleClick(that.index,true);
      }, 500);
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    default(e) {
      e.preventDefault();
    },
    //跳转外链
    linkUrl(url) {
      window.location.href = url;
    },
    getNumPages(url) {
      var loadingTask = pdf.createLoadingTask(url,{withCredentials: false});
      
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch((err) => {
        console.error('pdf加载失败')
      })
    },
    pdfClose(){
      this.pdfUrl='';
      this.pdfDialog = false;
    },
    //打开pdf预览弹窗
    goPreview(item){
      if(item.file){
        this.pdfUrl= imgUrl.imgUrl(item.file);
        this.getNumPages(this.pdfUrl)
        this.pdfDialog =true
      }else{
        this.$message({
          message: 'no pdf',
          type: 'warning',
          offset:120,
          center: true
        });
      }
    },
    downloadFile(url){
      var x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e) {
          var url = window.URL.createObjectURL(x.response)
          var a = document.createElement('a');
          a.href = url
          a.download = '';
          a.click()
      }
      x.send();
    },
    //产品目录
    getProductList(catid) {
      axios.get("/api/product",{catid:catid}).then((res) => {
        if (res.code == 1) {
          this.productClassList=res.data.category
          this.productList=res.data.category
          res.data.category.forEach((m, index) => {
            for (let i = 0; i < this.productList.length; i++) {
              if (this.productList[i]["list"]) {
                this.productList[i]["list"].forEach((item, indexs) => {
                  if(index == i ){
                    this.$set(item, 'maskShow', false)
                  }
                });
              }
            }
          });
        }
      });
    },
    showMask(item) {
      item.maskShow = !item.maskShow;
      this.$forceUpdate;
    },
    
    handleClick(index) {
      // var index = tab.index
      var that = this;
      that.tabOpt = index;
      let jump = document.querySelectorAll(".tab");
      let total = jump[index].offsetTop - 70;
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }
      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.body.scrollTop = total - 100;
          document.documentElement.scrollTop = total - 100;
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 58) {
        this.maxscrollTop = true;
      } else {
        this.maxscrollTop = false;
      }
    },
    
  },
};
</script>
<style scoped>
/* 产品 场景 */
.indexSwiperBanner .swiper-container {
  height: 520px;
}
.indexSwiperBanner .swiper-container img {
  display: block;
  width: 100%;
  height: 100%;
}
/deep/.swiper-pagination .swiper-pagination-bullet {
  width: 14px;
  height: 14px;
  background: #fcfcfe;
  opacity: 0.75;
  border-radius: 50%;
}
/deep/.swiper-pagination .swiper-pagination-bullet-active {
  width: 40px;
  height: 14px;
  background: #fcfcfe;
  opacity: 0.5;
  border-radius: 7px;
}
/deep/.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 48px;
}
.el-select {
  width: 100%;
}
/deep/.el-form-item__label {
  color: #333;
  font-weight: bold;
}
/deep/.codeBox .el-input {
  width: 300px;
  vertical-align: middle;
}
.sxBtn {
  position: absolute;
  left: 270px;
  width: 22px;
  height: 19px;
  top: 10px;
}
.codeImg {
  width: 99px;
  height: 38px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
}
.formsBox,
#formsBox {
  padding: 0 !important;
}
.newsBg span,
.newsBg strong {
  color: white;
  line-height: 22px;
}
.newsBg strong {
  width: auto;
}
.sortNav {
  width: 1400px;
  height: 130px;
  background: #fbfbfb;
  border-radius: 12px;
  position: absolute;
  left: 50%;
  bottom: -90px;
  margin-left: -700px;
}
.productNavBox,
.secondaryNavBox {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  overflow-x: auto;
}
.productNavList,
.secondaryNavList {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 67px;
  position: relative;
  padding: 0 30px;
}
.productNavList .text {
  font-size: 14px;
  color: #666666;
}
.productNavList .line {
  display: none;
}
.navSelected .text {
  font-weight: bold;
  color: #010101;
}
.navSelected .line {
  display: block;
  width: 54px;
  height: 2px;
  background: #267fe9;
  position: absolute;
  bottom: 0px;
}
.secondaryNavList {
  height: 60px;
}
.secondaryNavList .text {
  font-size: 14px;
  color: #666666;
}
.secondarySelected .text {
  color: #267fe9;
}
.productBox {
  min-height: 90px;
  /* padding-top: 90px; */
  padding-bottom: 20px;
  box-sizing: border-box;
}

.productImg {
  width: 100%;
  height: 410px;
  border-radius: 10px;
  position: absolute;
  z-index: -1;
}
.productName {
  font-size: 16px;
  font-family: Helvetica Neue;
  font-weight: 400;
  color: #333;
  line-height: 32px;
  margin-top: 12px;
}
.productDec {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  /* line-height: 42px; */
}
.textArea {
  text-align: left;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 38px;
  background: #000000;
  box-shadow: 0px 8px 21px 0px rgba(229, 229, 229, 0.1);
  opacity: 0.5;
  border-radius: 0px 0px 10px 10px;
  color: #f7f7f7;
  padding: 0px 22px 0px 21px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: normal;
  line-height: 38px;
}
.pagination {
  margin-top: 20px;
}

.navBox {
  justify-content: flex-start;
  padding: 0 10.9vw;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.productListBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  /* overflow-x: auto; */
  flex-wrap: wrap;
  width: 1434px;
  margin: 0 auto;
}
.productListPart {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
}
.productList {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
  position: relative;
}
.productItem {
  width: 332px;
  height: 410px;
  box-sizing: border-box;
  transition: color 0.5s;
  -webkit-transition: color 0.5s;
  /* margin: 0 12px 16px 12px; */
  border-radius: 10px;
  margin-top: 9px;
  margin-bottom: 25px;
  position: relative;
}
.productItem:hover {
  transform: scaleX(1.09);
  transform: scaleY(1.05);

  box-shadow: 0px 0px 14px 2px rgba(137, 137, 137, 0.31);
  -webkit-transition: color 0.5s;
}
.productItem:hover .productImg {
  width: 100%;
  height: 100%;
}
/* .productList:hover .productNmae {
  color: #267fe9;
} */
.productItem:not(:nth-child(4n)) {
  margin-right: 24px;
  margin-bottom: 16px;
}
.productItem:nth-child(4n-3) {
  margin-left: 17px;
}

.productItem:nth-child(4n) {
  margin-right: 17px;
}
.className {
  width: 100%;
  margin-top: 40px;
  margin-bottom: 47px;
  margin-left: 17px;
  flex-shrink: 0;
  font-weight: bold;
  color: #333;
  font-size: 18px;
}
/* mask */
.product_mask {
  width: 100%;
  height: 100%;
  background: #000000;
  box-shadow: 0px 0px 14px 2px rgba(137, 137, 137, 0.31);
  opacity: 0.5;
  border-radius: 10px;
  position: absolute;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.preview_btn {
  width: 180px;
  height: 38px;
  border: 1px solid #ffffff;
  border-radius: 4px;

  font-size: 18px;
  font-weight: normal;
  color: #f7f7f7;
  line-height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.preview_btn img {
  margin-right: 7px;
}
.dialog {
  position: fixed;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  /* pointer-events: none; */
  visibility: visible;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999999;
}
.dialog .mask {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: -1;
  background: rgba(0, 0, 0, 0.8);
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  transition-duration: 0.3s;
  -webkit-backface-visibility: hidden;
}
.dialog .dialog_content {
  position: relative;
  width: auto;
  max-width: inherit;
  min-width: inherit;
  padding: 1em 5px 0 5px;
  background: #fff;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  -webkit-animation-name: anim-open-6;
  animation-name: anim-open-6;
  opacity: 1;
  pointer-events: auto;
  border-radius: 10px;
  width: 41.6vw;
  height: 80vh;
  /* overflow: hidden; */
}
.pdfBox{
  height: calc(100% - 60px);
  overflow-y: scroll;
}
.pdfBox::-webkit-scrollbar{
  width: 10px;
  height: 100%;
  background-color: #F5F5F5;
}
.pdfBox::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  background   : #535353;
  }
.pdfBox::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background   : #ededed;
}
.dialog .dialog_content a{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #FFFFFF;
  border-radius: 0px 0px 10px 10px;
  text-align: center;
}
.dialog .dialog_content a i{
  margin-top:18px;
  width: 26px;
  height: 24px;
  content: url(../../src/img/download.png);
}
.dialogPdfClose {
  position: absolute;
  font-size: 29px;
  right: -20px;
  color: #e6e6e6;
  top: -4px;
  right: -46px;
}
</style>

